module.exports = __webpack_public_path__ + "static/media/alret.6368072c.svg";